/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2
 */
import * as References from './AutomationEmbeddedServiceV2';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllowedActionTypes
 */
export const FETCH_ALLOWED_ACTION_TYPES_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllowedActionTypes';
export const FETCH_ALLOWED_ACTION_TYPES_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.FetchAllowedActionTypesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_ALLOWED_ACTION_TYPES_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchAllowedActionTypesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchAllowedActionTypesRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllowedTriggers
 */
export const FETCH_ALLOWED_TRIGGERS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllowedTriggers';
export const FETCH_ALLOWED_TRIGGERS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.FetchAllowedTriggersResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_ALLOWED_TRIGGERS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchAllowedTriggersResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchAllowedTriggersRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchPermissions
 */
export const FETCH_PERMISSIONS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchPermissions';
export const FETCH_PERMISSIONS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.FetchPermissionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_PERMISSIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchPermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchPermissionsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchEmbeddedSummary
 */
export const FETCH_EMBEDDED_SUMMARY_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchEmbeddedSummary';
export const FETCH_EMBEDDED_SUMMARY_QUERY: RegisteredQuery<
  'result',
  References.FetchEmbeddedSummaryRequestType,
  References.FetchEmbeddedSummaryResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_EMBEDDED_SUMMARY_QUERY_FIELD_NAME,
  args: ['target', 'relatedAutomationsPageSize', 'allAutomationsPageSize'],
  fetcher(
    request: References.FetchEmbeddedSummaryRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchEmbeddedSummaryResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchEmbeddedSummaryRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchRelatedAutomations
 */
export const FETCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchRelatedAutomations';
export const FETCH_RELATED_AUTOMATIONS_QUERY: RegisteredQuery<
  'result',
  References.FetchRelatedAutomationsRequestType,
  References.FetchRelatedAutomationsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME,
  args: [
    'target',
    'flowKinds',
    'sourceApps',
    'compatibleBuilders',
    'sortDirection',
    'pageLength',
    'offset',
  ],
  fetcher(
    request: References.FetchRelatedAutomationsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchRelatedAutomationsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchRelatedAutomationsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchAllAutomations
 */
export const FETCH_ALL_AUTOMATIONS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchAllAutomations';
export const FETCH_ALL_AUTOMATIONS_QUERY: RegisteredQuery<
  'result',
  References.FetchAllAutomationsRequestType,
  References.FetchAllAutomationsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_ALL_AUTOMATIONS_QUERY_FIELD_NAME,
  args: [
    'flowKinds',
    'sourceApps',
    'compatibleBuilders',
    'sortDirection',
    'pageLength',
    'offset',
  ],
  fetcher(
    request: References.FetchAllAutomationsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchAllAutomationsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchAllAutomationsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#searchRelatedAutomations
 */
export const SEARCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_searchRelatedAutomations';
export const SEARCH_RELATED_AUTOMATIONS_QUERY: RegisteredQuery<
  'result',
  References.SearchRelatedAutomationsRequestType,
  References.SearchRelatedAutomationsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_RELATED_AUTOMATIONS_QUERY_FIELD_NAME,
  args: [
    'target',
    'searchQuery',
    'flowKinds',
    'sourceApps',
    'compatibleBuilders',
    'sortDirection',
    'pageLength',
    'offset',
  ],
  fetcher(
    request: References.SearchRelatedAutomationsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchRelatedAutomationsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.searchRelatedAutomationsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchTemplates
 */
export const FETCH_TEMPLATES_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchTemplates';
export const FETCH_TEMPLATES_QUERY: RegisteredQuery<
  'result',
  References.FetchTemplatesRequestType,
  References.FetchTemplatesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_TEMPLATES_QUERY_FIELD_NAME,
  args: [
    'target',
    'search',
    'tags',
    'sortBy',
    'sortDirection',
    'pageLength',
    'offset',
  ],
  fetcher(
    request: References.FetchTemplatesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchTemplatesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchTemplatesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#fetchWorkflow
 */
export const FETCH_WORKFLOW_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_fetchWorkflow';
export const FETCH_WORKFLOW_QUERY: RegisteredQuery<
  'result',
  References.FetchWorkflowRequestType,
  References.FetchWorkflowResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_WORKFLOW_QUERY_FIELD_NAME,
  args: ['flowId'],
  fetcher(
    request: References.FetchWorkflowRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchWorkflowResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.fetchWorkflowRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.automation.embedded.rpc.AutomationEmbeddedServiceV2#resolveWorkflowLinks
 */
export const RESOLVE_WORKFLOW_LINKS_QUERY_FIELD_NAME =
  'com_hubspot_automation_embedded_rpc_AutomationEmbeddedServiceV2_resolveWorkflowLinks';
export const RESOLVE_WORKFLOW_LINKS_QUERY: RegisteredQuery<
  'result',
  References.ResolveWorkflowLinksRequestType,
  References.ResolveWorkflowLinksResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RESOLVE_WORKFLOW_LINKS_QUERY_FIELD_NAME,
  args: ['flowIds', 'baseUrl'],
  fetcher(
    request: References.ResolveWorkflowLinksRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ResolveWorkflowLinksResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.resolveWorkflowLinksRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
